module.exports = __webpack_public_path__ + "img/5297050.jpg";